import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const GraficoBarResultados = ({ resultados }) => {
  // Obtener totales por servicio
  const totales = {};

  resultados.forEach((resultado) => {
    const { NombreServ, fechaatn } = resultado;
    const estado = fechaatn ? 'Atendidos' : 'Por Atender';

    if (!totales[NombreServ]) {
      totales[NombreServ] = {
        'Por Atender': 0,
        'Atendidos': 0,
        'Total del día': 0,
      };
    }

    totales[NombreServ][estado]++;
    totales[NombreServ]['Total del día']++;
  });
  
  // Obtener nombres de servicios y valores de los totales
  const nombresServicios = Object.keys(totales);
  const valoresAtendidos = nombresServicios.map((servicio) => totales[servicio]['Atendidos']);
  const valoresPorAtender = nombresServicios.map((servicio) => totales[servicio]['Por Atender']);
  const valoresTotalDia = nombresServicios.map((servicio) => totales[servicio]['Total del día']);

  // Configuración del gráfico
  const data = {
    labels: nombresServicios,
    datasets: [
      {
        label: 'Total del día',
        data: valoresTotalDia,
        backgroundColor:'rgba(255, 159, 64, 0.2)',
        borderColor:'rgba(255, 159, 64)',
        borderWidth: 1,
      },
      {
        label: 'Por Atender',
        data: valoresPorAtender,
        backgroundColor:'rgba(255, 99, 132, 0.2)',
        borderColor:'rgba(255, 99, 132)',
        borderWidth: 1
      },
      {
        label: 'Atendidos',
        data: valoresAtendidos,
        borderWidth: 1,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor:'rgba(75, 192, 192)',
      },
    ],
  };
  
  const options = {
    scales: {
     y: {
        beginAtZero: true,
        grace:5,
      },
    },
    plugins: {
      tooltip: false,
      pointStyle:'circle',
      legend: {
          display: true,
          position:'bottom',
          onHover: (event) => {
            event.native.target.style.cursor = 'pointer'
        },
        onLeave: function (e) {
          e.target.style.cursor = 'default'
        },
        labels: {
          usePointStyle: true,
        },
      },
      datalabels:{anchor:'end',
      align:'end',}

      },
  };
  const topLabels = {
    id:'topLabels',
    afterDatasetsDraw(chart){
      const {ctx, data} = chart;
      ctx.save();
      chart.data.datasets.forEach((dataset, i) =>{
          chart.getDatasetMeta(i).data.forEach((datapoint, index) =>{
             const { x, y } = datapoint.tooltipPosition();
             ctx.font = '13px Roboto';
             ctx.fillStyle = dataset.borderColor[index];
             ctx.textAlign = 'center';
             ctx.fillText(data.datasets[i].data[index], x, y-6);
          })
       })
    }   
  }
  const plugins= [ topLabels ];
  return (
      <Bar data={data} options={options} plugins={plugins}/>
  );
};

export default GraficoBarResultados;
